// Fix Vuetify empty buttons
const fixButtonText = function (myClass, myText) {
  const myButtons = document.getElementsByClassName(myClass);

  for (let i = 0, len = myButtons.length; i < len; ++i) {
    const el = document.createElement("span");
    el.innerHTML = myText;
    el.classList.add("aria-hidden");
    myButtons[i].appendChild(el);
  }
};

// Fix Vuetify blank TH tag on expandable tables
const fixBlankTableHeadings = function () {
  const tableHeadings = document.getElementsByTagName("TH");
  for (let i = 0, len = tableHeadings.length; i < len; ++i) {
    if (tableHeadings[i].innerHTML === "<span></span>") {
      tableHeadings[i].innerHTML =
        "<span class='aria-hidden'>This cell is intentionally blank</span>";
    }
  }
};

// fix empty H2 headings with Nuxt 2.14+ sites using nuxt-content
const fixNuxtContentHeadings = function (querySelectors) {
  const els = document.querySelectorAll(querySelectors);
  for (let i = 0, len = els.length; i < len; ++i) {
    const subEl = els[i].querySelectorAll("a");
    for (let i = 0, len = subEl.length; i < len; ++i) {
      subEl[i].remove();
    }
  }
};

// Fix Vuetify 2 v-avatar and date inputs: removes invalid aria-expanded
// on elements where the ARIA spec does not allow it
const fixAvatarAriaExpanded = function () {
  // v-avatar elements
  const avatars = document.querySelectorAll(".v-avatar[aria-expanded]");
  for (let i = 0, len = avatars.length; i < len; ++i) {
    avatars[i].removeAttribute("aria-expanded");
  }
  // Input elements (e.g. Vuetify date pickers) that have aria-expanded
  // but no role that supports it
  const inputs = document.querySelectorAll("input[aria-expanded]");
  for (let i = 0, len = inputs.length; i < len; ++i) {
    var role = inputs[i].getAttribute("role");
    if (!role || role === "textbox") {
      inputs[i].removeAttribute("aria-expanded");
    }
  }
};

// Fix Vuetify 2 v-select/v-autocomplete: nested interactive controls
// The parent div has role="button" and contains natively focusable <input> children.
// We change role="button" to role="combobox" which supports both aria-expanded
// and aria-haspopup="listbox", and allows child input elements.
const fixNestedInteractive = function () {
  // Vuetify 2 renders v-select/v-autocomplete as a focusable wrapper div
  // (role="button" aria-haspopup="listbox") that CONTAINS a focusable <input>.
  // axe flags this as nested-interactive (4.1.2). The correct ARIA 1.2 combobox
  // pattern puts the combobox semantics on the input itself, so relocate them
  // there and strip the interactive role/aria off the wrapper div — that way an
  // interactive-role element no longer nests another focusable control.
  var wrappers = document.querySelectorAll(
    "div[aria-haspopup='listbox'], div.v-input__slot[aria-expanded]:not([role])"
  );
  for (var i = 0, len = wrappers.length; i < len; ++i) {
    var div = wrappers[i];
    var input = div.querySelector("input");
    if (input) {
      if (!input.getAttribute("role")) input.setAttribute("role", "combobox");
      input.setAttribute("aria-haspopup", "listbox");
      if (div.hasAttribute("aria-expanded")) {
        input.setAttribute("aria-expanded", div.getAttribute("aria-expanded"));
      }
      if (div.hasAttribute("aria-owns")) {
        input.setAttribute("aria-owns", div.getAttribute("aria-owns"));
      }
      div.removeAttribute("role");
      div.removeAttribute("aria-haspopup");
      div.removeAttribute("aria-expanded");
      div.removeAttribute("aria-owns");
    } else {
      // No inner input (rare) — fall back to a valid combobox role on the div.
      div.setAttribute("role", "combobox");
    }
  }
};

// Fix Vuetify 2 date inputs: removes invalid role="button" on input elements
const fixAriaAllowedRole = function () {
  const inputs = document.querySelectorAll('input[role="button"]');
  for (let i = 0, len = inputs.length; i < len; ++i) {
    inputs[i].removeAttribute("role");
  }
};

// Run all Vuetify 2 a11y patches at once
const fixVuetifyA11y = function () {
  fixAvatarAriaExpanded();
  fixNestedInteractive();
  fixAriaAllowedRole();
  fixBlankTableHeadings();
};

// MutationObserver-based watcher that patches Vuetify a11y issues
// as new elements are added to the DOM (e.g. after GraphQL data loads)
let _observer = null;
let _debounceTimer = null;

const startA11yObserver = function () {
  if (_observer) return; // already running

  // Patch immediately for anything already in the DOM
  fixVuetifyA11y();

  _observer = new MutationObserver(function () {
    // Debounce: batch rapid DOM changes into a single patch pass
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(fixVuetifyA11y, 300);
  });

  _observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-expanded", "aria-haspopup", "aria-owns", "role"],
  });
};

const stopA11yObserver = function () {
  if (_observer) {
    _observer.disconnect();
    _observer = null;
  }
  clearTimeout(_debounceTimer);
};

export {
  fixButtonText,
  fixBlankTableHeadings,
  fixNuxtContentHeadings,
  fixAvatarAriaExpanded,
  fixNestedInteractive,
  fixAriaAllowedRole,
  fixVuetifyA11y,
  startA11yObserver,
  stopA11yObserver,
};
